var siteMobileController = (function () {
    function siteMobileController(env) {
        this.env = env;
    }
    siteMobileController.prototype.closeMobileMenu = function () {
        var body = angular.element(document).find('body');
        body.removeClass('ibm-show-mobilemenu-screen ibm-mobilemenu-show ibm-no-scroll ibm-overlay-backdrop-visible');
    };
    siteMobileController.$inject = ['env'];
    return siteMobileController;
}());
var siteMobileComponent = (function () {
    function siteMobileComponent() {
        this.templateUrl = 'site-mobile.html';
        this.controllerAs = 'vm';
        this.controller = siteMobileController;
    }
    return siteMobileComponent;
}());
angular
    .module('application')
    .component('siteMobile', new siteMobileComponent());

//# sourceMappingURL=site.mobile.component.js.map
